import * as React from "react";
import Container from "./styled";
import {
  IoMailOutline,
  IoCallOutline,
  IoBusinessOutline,
} from "react-icons/io5";
import { Fade } from "react-awesome-reveal";

export default function DatosContacto() {
  return (
    <Container>
      <Fade
        delay={100}
        duration={700}
        triggerOnce={true}
        className="maxWidthContainer"
      >
        {/* Title */}
        <h2>Datos de contacto</h2>
        {/* Adress Data */}
        <div className="dataContainer">
          <p>
            <span>
              <IoBusinessOutline />
            </span>
            <strong>Dirección:</strong> Suipacha 245 6° Piso CABA
          </p>
          <p>
            <span>
              <IoCallOutline />
            </span>
            <strong>Teléfono:</strong>
            <a id="telefono1" href="tel:08102202373">
              0810-220-2373
            </a>
            <a id="telefono2" href="tel:1152632373">
              (011) 5263-2373
            </a>
          </p>
          <p id="email">
            <span>
              <IoMailOutline />
            </span>
            <strong>Email:</strong>
            <a href="mailto:info@segurobici.com.ar">info@segurobici.com.ar</a>
          </p>
        </div>
        {/* Google Maps */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.952818422825!2d-58.38140768382813!3d-34.60535456509365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccace477850f1%3A0x4c973e8332061355!2sGesti%C3%B3n%20y%20Servicios%20S.R.L.!5e0!3m2!1ses-419!2sar!4v1639418264150!5m2!1ses-419!2sar"
          width="100%"
          height="400"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </Fade>
    </Container>
  );
}
